import React from 'react';
// import Header from '../Header/Header';
import Hero from '../Home/Hero/Hero';
import Features from '../Home/Feature/Features';
import TrackingSection from '../Home/Tracking/TrackingSection';
import SyncSection from '../Home/Sync/SyncSection';
import ImprovementsSection from '../Home/Improvement/ImprovementsSection';
import CommunitySection from '../Home/Community/CommunitySection';
import OtherFeatures from '../Home/Other/OtherFeatures';
// import Footer from '../Footer/Footer';
import Testimonial from '../Home/Testimonial/Testimonial';
import SEO from '../SEO/SEO';
const HomePage = () => {
  return (
    <div className="min-h-screen bg-gray-100">
    <SEO
  title="Boldly English | Learn English with Confidence"
  description="Improve your English skills with interactive courses, roleplay, word games, and engaging learning activities."
  canonical="https://boldlyenglish.com/"
/>
  {/* <Header /> */}
      <main>
      <Hero />
      <Features />
      <SyncSection />
      <ImprovementsSection />
      <TrackingSection />
      
      
      <CommunitySection />
      <OtherFeatures />
      <Testimonial/>
      {/* <Test /> */}
    </main>
    {/* <Footer /> */}
  </div>
  );
};

export default HomePage;